"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.offerCreator.name': 'Creatore Offerte',
    'tools.offerCreator.description': 'Rileva e completa informazioni di offerta/preventivo dai messaggi degli utenti inclusi dettagli aziendali, tipi di tassazione e attività commerciali',
};
